import { FC } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

import useAuth from "@hooks/useAuth";
import { useCorban } from "@hooks/useCorban";
import usePermissions from "@hooks/usePermissions";

import PageLoading from "../PageLoading";

export const PageGuard: FC = () => {
  const location = useLocation();
  const { user } = useAuth();
  const { needCorbanSelection } = useCorban();
  const { homeRoute, isReady } = usePermissions();

  if (location.pathname === "/") {
    if (!user) {
      return <Navigate replace to="/login" />;
    }

    if (isReady) {
      return <Navigate replace to={homeRoute} />;
    }

    if (needCorbanSelection) {
      return <Navigate replace to="/selecao-corban" />;
    }

    return <PageLoading />;
  }

  return <Outlet />;
};
